
import Tree from "../../../assets/duotone/Tree.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TreeIcon({ className, dataTestid = "TreeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Tree data-testid={dataTestid} className={classes} {...rest} />
  );
}
